export default "__VITE_ASSET__74b4e529__"